import React from 'react';
import styles from './CheckboxField.module.scss';
import classNames from 'classnames';

type PropsType = {
  id?: string;
  name: string;
  label?: string;
  value?: string;
  checked: boolean;
  className?: string;
  disabled?: boolean;
  isHidden?: boolean;
  onChange?: (checked: boolean, e: any) => void;
};

const CheckboxField = (props: PropsType) => {
  const forValue = props.name.replace(/\s/g, '').toLowerCase();

  return (
    <div
      className={classNames(styles.wrapper, props.className)}
      style={props.isHidden ? { opacity: 0, position: 'absolute' } : undefined}
    >
      <input
        type="checkbox"
        name={props.name}
        id={forValue || props.id}
        value={props.value}
        checked={props.checked}
        className={styles.input}
        disabled={props.disabled}
        onChange={(e: any) => props.onChange && props.onChange(e.target.checked, e)}
      />

      <label htmlFor={forValue || props.id} className={styles.label}>
        {props.label}
      </label>
    </div>
  );
};

export default CheckboxField;
